/**
 * Export file type extensions
 */
export enum ExportType {
  CSV = 'csv',
  EXCEL = 'excel',
  PDF = 'pdf'
}

export const downloadExtension: Record<ExportType, string> = {
  [ExportType.CSV]: 'csv',
  [ExportType.EXCEL]: 'xlsx',
  [ExportType.PDF]: 'pdf'
}
